import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useForm, Controller } from 'react-hook-form';
import { CreateChancel, DateCalendarForm, Input, SelectAutocompletePagination } from 'components';
import { clientStatusEnums, FindLoad, FindSuccess, renderClientName, useModal } from 'utils';
import { adminActions, httpRequestsOnSuccessActions } from 'store';

export const AssignClientToStaff = ({ item }) => {
    const { staffGeneral } = useSelector((state) => ({ staffGeneral: state.admins.adminInfoById }));
    const isEdit = !!item;
    const ACTION_TYPE = isEdit ? 'EDIT_ASSIGNED_CLIENTS_FROM_STAFF' : 'ASSIGN_CLIENTS_TO_STAFF';
    const staffClients = useSelector((state) => state.admins.staffClients);
    const dispatch = useDispatch();
    const { close } = useModal();
    const loader = FindLoad(ACTION_TYPE);
    const success = FindSuccess(ACTION_TYPE);
    const { handleSubmit, control, reset } = useForm({
        defaultValues: {
            client: null,
            role: '',
            assignmentDate: null,
        },
    });

    useEffect(() => {
        if (item) {
            reset({
                client: item?.clientId,
                role: item?.staffRole,
                assignmentDate: item?.assignmentDate || null,
            });
        }
    }, [item]);

    useEffect(() => {
        if (success?.length) {
            close();
            dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
        }
    }, [success]);

    const filterList = (clients) => {
        return clients?.filter(
            (array_el) => staffClients?.filter((anotherOne_el) => anotherOne_el?.clientId === array_el?.id).length === 0
        );
    };

    const handleCreate = (data) => {
        if (isEdit) {
            const sendParams = {
                staffId: staffGeneral?.id,
                clientId: item?.clientId,
                role: data?.role,
                assignmentDate: data?.assignmentDate,
            };
            dispatch(adminActions.editAssignClientFromStaff(item?.assignedId, sendParams, staffGeneral?.id));
        } else {
            const sendParams = {
                staffId: staffGeneral?.id,
                clientId: data?.client,
                role: data?.role,
                assign: true,
            };
            data?.assignmentDate && (sendParams['assignmentDate'] = data?.assignmentDate);
            dispatch(adminActions.assignClientToStaff(sendParams, staffGeneral?.id));
        }
    };

    return (
        <form onSubmit={handleSubmit(handleCreate)} style={{ width: 400 }}>
            <p className="modal-header-title">{isEdit ? 'Edit Assigned Client' : 'Assign Client'}</p>
            <div className="modal-body-wrapper flex-align-start" style={{ gap: 24 }}>
                <div className="full-width">
                    {!isEdit && (
                        <Controller
                            name="client"
                            control={control}
                            rules={{ required: 'Client is required.' }}
                            render={({ field, fieldState }) => (
                                <SelectAutocompletePagination
                                    style={'full-width'}
                                    filterOptions={(options) => filterList(options)}
                                    defaultStatuses={[clientStatusEnums.ACTIVE]}
                                    title={'Client*'}
                                    placeholder={'Select Client*'}
                                    name={'client'}
                                    handleSelect={(e) => field.onChange(e.target.value)}
                                    defaultValue={field.value}
                                    renderValue={(i) => renderClientName(i)}
                                    type={'client'}
                                    error={fieldState.error ? 'client' : ''}
                                    typeError={fieldState.error?.message}
                                />
                            )}
                        />
                    )}
                    <Input
                        name="role"
                        label="Client Role*"
                        variant="outlined"
                        control={control}
                        maxLength={20}
                        rules={{
                            maxLength: { value: 20, message: 'Max length is 20.' },
                            required: 'Client role is required.',
                        }}
                    />
                    {}
                    <DateCalendarForm name={'assignmentDate'} label={'Assignment Date'} control={control} />
                </div>
            </div>
            <CreateChancel
                type="submit"
                loader={!!loader.length}
                create={isEdit ? 'Save' : 'Assign Client'}
                chancel={'Cancel'}
                onClose={close}
                buttonWidth="100%"
            />
        </form>
    );
};
